/**
 * Tymes4 Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CreditChangeAction = 0 | 1 | 2 | 3 | 4;

export const CreditChangeAction = {
    PROFIT: 0 as CreditChangeAction,
    CASH_REFUND: 1 as CreditChangeAction,
    ALTERNATIVE_REFUND: 2 as CreditChangeAction,
    ORDERLINE_REVISION: 3 as CreditChangeAction,
    ORDER_PAYMENT: 4 as CreditChangeAction
};

